export default __webpack_public_path__ + "static/media/yl.79f786e0.jpg";